export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio',
  },
  {
    title: that.$l('table_label_retailerPo') || '零售商PO',
    field: 'retailerPo',
    minWidth: 150,
    align: 'center'
  },
  {
    title: that.$l('table_label_importerPo') || '代理商PO',
    field: 'importerPo',
    minWidth: 150,
    align: 'center'
  },
  {
    title: that.$l('table_label_orderGoodsNameEn') || '英文名称',
    field: 'orderGoodsNameEn',
    minWidth: 200,
    align: 'left',
    showOverflow: true
  },
  {
    title: that.$l('table_label_orderGoodsName') || '中文名称',
    field: 'orderGoodsName',
    minWidth: 200,
    align: 'left',
    showOverflow: true
  },
  {
    title: that.$l('table_label_isGroupName') || '是否套装',
    field: 'isGroupName',
    minWidth: 100,
    align: 'center'
  },
  {
    title: that.$l('table_label_orderGoodsEnglishSize') || '尺寸',
    field: 'orderGoodsEnglishSize',
    minWidth: 120,
    align: 'center'
  },
  {
    title: that.$l('table_label_orderGoodsColor') || '中文颜色',
    field: 'orderGoodsColor',
    minWidth: 200,
    align: 'center',
    showOverflow: true
  },
  {
    title: that.$l('table_label_qty') || '订单数量',
    field: 'qty',
    minWidth: 100,
    align: 'center'
  },
  {
    title: that.$l('table_label_cargoReadyDay') || '装好时间',
    field: 'cargoReadyDay',
    minWidth: 140,
    align: 'center'
  },
  {
    title: that.$l('table_label_shipmentDate') || '客户最早交期',
    field: 'shipmentDate',
    minWidth: 140,
    align: 'center'
  },
  {
    title: that.$l('table_label_shipmentEndDate') || '客户最晚交期',
    field: 'shipmentEndDate',
    minWidth: 140,
    align: 'center'
  },
  {
    title: that.$l('table_label_scmName') || '执行工厂',
    field: 'scmName',
    minWidth: 200,
    align: 'center'
  },
  {
    title: that.$l('table_label_orderScmCodeName') || '名义工厂',
    field: 'orderScmCodeName',
    minWidth: 200,
    align: 'center'
  }
]
